// extracted by extract-css-chunks-webpack-plugin
module.exports = {"panel":"panel_1jE81","form":"form_6lvXY"};